<template>
  <v-row justify="space-between" align="center" class="mb-4">
    <v-col>
      <h2 class="text-h5">Student Management</h2>
    </v-col>
    <v-btn color="primary" @click="isAddDialogOpen = true">
      + Add Students
    </v-btn>
  </v-row>
  <!-- Add User Dialog -->
  <v-dialog v-model="isAddDialogOpen" max-width="950px">
    <v-card>
      <!-- Top Section: Title and Cancel Button -->
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6">Add New Student</span>
        <v-btn icon @click="isAddDialogOpen = false">
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Main Form -->
      <v-card-text>
        <v-form ref="addStudentForm" @submit.prevent="addStudents">
          <v-container>
            <v-row>
              <!-- Student Credentials -->
              <v-col cols="12">
                <v-card-text class="text-body-1 font-weight-bold">
                  Student Credentials
                </v-card-text>
              </v-col>

              <!-- Full Name -->
              <v-col cols="12" md="5">
                <v-text-field v-model="newStudent.name" label="Full Name" outlined required
                  hint="Enter the student's full name" persistent-hint></v-text-field>
              </v-col>

              <!-- Roll No -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newStudent.roll_symbol_no" label="Roll No." outlined required
                  hint="Enter the student's Roll No." persistent-hint></v-text-field>
              </v-col>

              <!-- Gender -->
              <!-- <v-col cols="12" md="4">
                <v-select
                  v-model="newStudent.gender"
                  :items="['Male', 'Female', 'Other']"
                  label="Gender"
                  outlined
                  required
                ></v-select>
              </v-col> -->
            </v-row>

            <v-row>
              <!-- Student Info -->
              <v-col cols="12">
                <v-card-text class="text-body-1 font-weight-bold">
                  Student Info
                </v-card-text>
              </v-col>

              <!-- Address -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newStudent.address" label="Address" outlined required></v-text-field>
              </v-col>

              <!-- Contact -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newStudent.contact" label="Contact" type="tel" outlined required></v-text-field>
              </v-col>

              <!-- Date of Birth -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newStudent.birth_date" label="Birth Date" type="text" hint="yyyy-mm-dd" outlined
                  required></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <!-- Parent Name -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newStudent.parent_name" label="Parent Name" outlined required></v-text-field>
              </v-col>
              <!-- Image Upload -->
              <v-col cols="12" md="4">
                <v-file-input v-model="newStudent.image" label="Upload Student image" outlined accept="image/*"
                  @change="(file) => onFileChange(file, 'image')"></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <!-- Bottom Section: Save Button -->
      <v-card-actions class="d-flex justify-end">
        <v-btn class="save-button" dark elevation="2" rounded @click="addStudents">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { addStudentView, schoolDetail } from "@/services/apiServices";
import { useSchoolStore } from "@/Store/className.js";
import { useTheme } from '@/composables/useThemes'
const { isDarkTheme } = useTheme()

const error = ref("");

const route = useRoute();

const classIdFromRoute = parseInt(route.params.id);
const classInfoList = JSON.parse(localStorage.getItem("classNamesList"));

const schoolInfoList = JSON.parse(localStorage.getItem("schoolDetails"));
const schoolId = schoolInfoList?.id;

const className = classInfoList?.find(
  (item) => item.id === classIdFromRoute
)?.name;

const isAddDialogOpen = ref(false);
const emit = defineEmits(["addedStudent"]);
const newStudent = ref({
  name: "",
  class_info: [classIdFromRoute],
  // class_name: className,
  class_name: '',
  // roll_no: "",
  roll_symbol_no: "",
  address: "",
  contact: "",
  birth_date: "",
  parent_name: "",
  gender: "",
  image: null,
  school: [schoolId],
});

const fetchSchool = async () => {
  try {
    const data = await schoolDetail();
    if (data && data.id) {
      newStudent.value.school = [data.id];
    }
  } catch (err) {
    error.value =
      err.response?.data?.message || "Failed to load school details";
  }
};

const onFileChange = (event, type) => {
  // Access the FileList from the event's target.
  const fileList = event.target.files;

  if (fileList && fileList.length > 0) {
    // Get the first selected file (you can handle multiple files if needed).
    const file = fileList[0];

    if (file instanceof File) {
      newStudent.value[type] = file;
    } else {
      console.error("Invalid file type:", file);
    }
  } else {
    console.error("No file selected or invalid FileList:", fileList);
  }
};

const addStudents = async () => {
  try {
    const formData = new FormData();
    Object.keys(newStudent.value).forEach((key) => {
      console.log("key:", key, newStudent.value);
      if (key !== "image") {
        formData.append(key, newStudent.value[key]);
      }
      if (key === "gender") {
        formData.set(key, newStudent.value[key].toLowerCase());
      }
    });

    if (newStudent.value.image instanceof File) {
      formData.append("image", newStudent.value.image);
    } else {
      console.error("No valid image file selected");
    }
    console.log('template ma school name:', formData)
    const response = await addStudentView(formData, route.params.id);
    console.log("formDatassas",response)
    if (response) {
      emit("addedStudent", response);
      isAddDialogOpen.value = false;

      // Direct Form Reset
      for (const key in newStudent.value) {
        if (key === "class_info" || key === "school" || key === "class_name") {
          continue; // Skip these fields and don't reset them.
        }
        newStudent.value[key] = Array.isArray(newStudent.value[key]) ? [] : ""; // Reset other fields.
      }

      // Set specific default values back
      newStudent.value.class_info = [classIdFromRoute];
      newStudent.value.school = [schoolId];
      newStudent.value.class_name = className;

      Swal.fire({
        icon: "success",
        title: "Student added successfully",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: isDarkTheme.value ? '#333' : '#fff',
        color: isDarkTheme.value ? '#fff' : '#000',
        iconColor: isDarkTheme ? "#0f0" : "#28a745",
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
    }
  } catch (error) {
    console.error("Error adding student:", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Failed to add student. Please try again.",
    });
  }
};

onMounted(fetchSchool);
</script>

<style scoped>
.save-button {
  background: linear-gradient(90deg, #4caf50, #43a047);
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>
